// components/TeamMemberCard.tsx

import Image from 'next/image';
import { Card } from '@/components/ui/card';

type TeamMemberCardProps = {
  imageUrl: string;
  name: string;
  role: string;
  isparent?: boolean;
  onClick: () => void; // Add onClick prop
};

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({ imageUrl, name, role, isparent, onClick }) => {
  return (
    // Wrap with a div and add the onClick handler and cursor style
    <div onClick={onClick} className="cursor-pointer group">
      <Card
        className={`${isparent ? 'text-foreground' : 'bg-prime-hover text-white'}
        text-center px-2 py-4 lg:py-6 rounded-2xl border border-ring 
        flex flex-col gap-2 items-center justify-center shadow-sm 
        group-hover:shadow-xl group-hover:scale-105 transition-all duration-300 h-full`}
      >
        <div className="relative w-24 h-24 md:w-32 md:h-32 lg:w-36 lg:h-36 mb-3">
          <Image
            src={imageUrl}
            alt={name ? `Profile picture of ${name}` : 'Team member'}
            fill
            className="rounded-full object-contain"
            sizes="(max-width: 768px) 96px, (max-width: 1200px) 200px, 200px"
            priority={isparent}
          />
        </div>
        <div>
          <h3 className="font-semibold text-sm md:text-base">{name}</h3>
          <p className="text-xs md:text-sm opacity-80">{role}</p>
        </div>
      </Card>
    </div>
  );
};

export default TeamMemberCard;